import { getToken } from "services/auth/tokenAuth";
import doRequest from "./client";
import { getUserId } from "services/storage/general";
import { EMPLOYABILITY_ENDPOINTS } from "./constants";
import { mapBaseResponse, mapReassignmentCandidateToUI } from "./mappers";

const getErrorMessage = err =>
    err?.response?.data?.data?.descripcion ||
    err?.response?.data?.data?.message ||
    err?.response?.data?.msg ||
    err?.response?.data?.message ||
    null;

const requestCandidates = async (endpoint, body) => {
    const [result, err] = await doRequest(
        endpoint,
        "POST",
        {
            ...body,
            codigoUsuario: getUserId()
        },
        getToken()
    );
    if (err) return null;
    const response = mapBaseResponse(result);
    if (!response.success) return null;
    const candidates = response.data?.candidatos || response.data?.items || [];
    return candidates.map(mapReassignmentCandidateToUI);
};

export const requestSearchSameSlotCandidates = reservationId =>
    requestCandidates(
        EMPLOYABILITY_ENDPOINTS.REASSIGN_SAME_SLOT(reservationId),
        {}
    );

export const requestSearchAlternativeCandidates = (reservationId, filters = {}) =>
    requestCandidates(
        EMPLOYABILITY_ENDPOINTS.REASSIGN_ALTERNATIVES(reservationId),
        {
            fechaDesde: filters.dateFrom ?? null,
            fechaHasta: filters.dateTo ?? null,
            soloMismaModalidad: filters.onlySameModality ?? true,
            soloCampusCompatibles: filters.onlyCompatibleCampus ?? true
        }
    );

export const requestReassignReservation = async ({
    reservationId,
    appointmentDateId,
    timeStart,
    timeEnd,
    reason
}) => {
    const [result, err] = await doRequest(
        EMPLOYABILITY_ENDPOINTS.REASSIGN(reservationId),
        "POST",
        {
            idAsesoriaFechaDestino: appointmentDateId,
            horaInicioDestino: timeStart,
            horaFinDestino: timeEnd,
            motivo: reason,
            codigoUsuario: getUserId()
        },
        getToken()
    );
    if (err) return {
        success: false,
        message: getErrorMessage(err)
    };
    const response = mapBaseResponse(result);
    return {
        success: response.success,
        message: response.description || response.message,
        responseCode: response.responseCode
    };
};

export const requestGetReassignmentHistory = async reservationId => {
    const endpoint = `${EMPLOYABILITY_ENDPOINTS.REASSIGN_HISTORY(reservationId)}?codigoUsuario=${encodeURIComponent(getUserId())}`;
    const [result, err] = await doRequest(endpoint, "GET", null, getToken());
    if (err) return null;
    const response = mapBaseResponse(result);
    return response.success ? response.data : null;
};
